import {useEffect, useRef} from "react";

import $ from "jquery";
import "../libraries/fieldslinker/fieldsLinker.js"
import "../libraries/fieldslinker/fieldsLinker.scss"
import Alert from "./alert";
import {match_links} from "../config/tips";
import PerfectScrollbar from "react-perfect-scrollbar";
import Button from "./button";
import {UseMessage} from "../hooks/UseMessage";
import {UsePost} from "../hooks/http";


let $linker = {}
const options = {
    buttonErase    : false,
    displayMode    : "original",
    associationMode: "oneToOne",
    lineStyle      : "square-ends",
}


const Importer = (props) => {
    const {origins, targets, endpoint, uploadState, onStart, id_audience} = props
    const linkRef = useRef()

    const startImport = (event) => {
        event.preventDefault()
        const result = $linker.fieldsLinker("getLinks")
        if (result?.error) {
            UseMessage("error", result.errorMessage)
        } else {


            UsePost(
                endpoint, {
                    data: {
                        id_audience: id_audience,
                        id_process : uploadState?.id_process,
                        countryDial: uploadState?.country?.value,
                        links      : JSON.stringify(result?.links),
                    }
                }
            ).then((response) => {
                onStart()
            })


            /*request.then(async (response) => {
                const data = await response.json()


                UseBtnLoading(event, true)
                if (response.status == 202) {
                    props.onStartImport(data.id_process)
                }

                if (response.status == 422) {
                    setIsLoading(false)
                    UseBtnLoading(event, false)
                }
            })*/
        }

        /**/

        /*console.log()*/


        /*UseBtnLoading(event, true)







        request.catch((error) => {
            console.log(error)
        })*/
    }


    const clearLinks = (event) => {
        $linker.fieldsLinker("eraseLinks");
    }


    useEffect(() => {
        $linker = $(linkRef.current)
        $linker.fieldsLinker("init", {
            options: options,
            Lists  : [origins, targets]
        });
    }, [origins, targets])


    return (
        <div className="linker Matching">
            <Alert icon="info" message={match_links}/>
            <PerfectScrollbar>
                <div ref={linkRef}/>
            </PerfectScrollbar>
            <div className="make-scroll"></div>
            <div className="d-flex mt-3">
                <Button
                    size="sm"
                    isReady={true}
                    color="primary"
                    icon="upload"
                    label="Start Import"
                    className="me-2"
                    onClick={startImport}
                />
                <Button
                    size="sm"
                    isReady={true}
                    color="secondary"
                    icon="delete"
                    label="Reset Links"
                    onClick={clearLinks}
                />
            </div>
        </div>
    )
}

export default Importer